"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  backgroundColor: theme.palette.grey[100],
  alignItems: 'center',
  height: 60
}));
//# sourceMappingURL=styles.js.map